import React from 'react';
import { 
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Chip
} from '@mui/material';
import { ReviewTypeBadge } from '../ReviewTypeBadge';
import { 
  getReviewTypeColor,
  getReviewTypeTextColor,
  getReviewTypeText
} from '../../../constants/reviewTypes';

const FeedbackSessionSelector = ({ 
  selectedSession = '',
  onSessionChange,
  sessionOptions = [],
  sx = {},
  width = '300px',
  showNoSession = false,
  noSessionLabel = 'No Session'
}) => {
  const handleChange = (event) => {
    const sessionId = event.target.value;
    onSessionChange(sessionId);
  };

  return (
    <FormControl sx={{ width, ...sx }}>
      <InputLabel 
        id="feedback-session-label"
        size="small"
        sx={{
          backgroundColor: 'white',
          px: 0.5,
          transform: 'translate(14px, -9px) scale(0.75)',
          '&.Mui-focused': {
            transform: 'translate(14px, -9px) scale(0.75)',
          },
          '&.MuiFormLabel-filled': {
            transform: 'translate(14px, -9px) scale(0.75)',
          }
        }}
      >
        Feedback Session
      </InputLabel>
      <Select
        labelId="feedback-session-label"
        label="Feedback Session"
        value={selectedSession}
        onChange={handleChange}
        displayEmpty
        renderValue={(selected) => {
          if (selected === '') return 'All Sessions';
          if (selected === 'no-session') return noSessionLabel;
          return sessionOptions.find(s => s.id === selected)?.name;
        }}
        variant="outlined"
        size="small"
        sx={{
          backgroundColor: 'white',
          height: '40px',
          fontSize: '14px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E2E8F0',
            legend: {
              width: '0px !important'
            }
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2563eb',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2563eb',
          },
          '& .MuiSelect-select': {
            padding: '8px 14px',
          }
        }}
      >
        <MenuItem 
          value="" 
          sx={{
            borderBottom: showNoSession ? 'none' : '1px solid #E2E8F0',
            color: '#64748B',
            fontWeight: 500,
            mb: showNoSession ? 0 : 1,
            '&:hover': {
              backgroundColor: '#F8FAFC'
            }
          }}
        >
          All Sessions
        </MenuItem>
        {showNoSession && (
          <MenuItem 
            value="no-session" 
            sx={{
              borderBottom: '1px solid #E2E8F0',
              color: '#64748B',
              fontWeight: 500,
              mb: 1,
              '&:hover': {
                backgroundColor: '#F8FAFC'
              }
            }}
          >
            {noSessionLabel}
          </MenuItem>
        )}
        {sessionOptions.map((session) => (
          <MenuItem 
            key={session.id} 
            value={session.id}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              py: 1
            }}
          >
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center',
              gap: 1,
              flex: 1
            }}>
              <span style={{ fontWeight: 500 }}>{session.name}</span>
              <Chip
                label={`${session.month} / ${session.year}`}
                size="small"
                sx={{
                  height: '24px',
                  fontSize: '12px',
                  backgroundColor: '#F1F5F9',
                  color: '#64748B',
                  fontWeight: 500,
                  '& .MuiChip-label': {
                    padding: '0 8px'
                  }
                }}
              />
              <ReviewTypeBadge 
                reviewType={session.reviewType}
                getReviewTypeColor={getReviewTypeColor}
                getReviewTypeTextColor={getReviewTypeTextColor}
                getReviewTypeText={getReviewTypeText}
              />
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FeedbackSessionSelector; 